import { createStore, useStore } from 'zustand';
import type { api } from '../api';

type AuditEffectsQuery = NonNullable<
  api['/audit/effects']['get']['parameters']['query']
>;

type AuditEffectsFilter = {
  search: string | null;
  status: NonNullable<AuditEffectsQuery['status']> | null;
  effectType: NonNullable<AuditEffectsQuery['effectType']> | null;
  entityType: NonNullable<AuditEffectsQuery['entityType']> | null;
};

type AuditEffectsWhere = {
  actionId?: string | undefined;
  entityId?: string | undefined;
};

type AuditEffectsState = {
  where: AuditEffectsWhere | null;
  filter: AuditEffectsFilter;
};

type AuditEffectsActions = {
  open: (where: AuditEffectsWhere) => void;
  close: () => void;
  setFilter: (filter: Partial<AuditEffectsFilter>) => void;
};

const initialAuditEffectsFilter: AuditEffectsFilter = {
  search: null,
  status: null,
  effectType: null,
  entityType: null,
};

const auditEffectsModalStore = createStore<
  AuditEffectsState & AuditEffectsActions
>((set, get) => ({
  close: () => set({ where: null, filter: initialAuditEffectsFilter }),
  open: (where) => set({ where }),
  setFilter: (filter) => set({ filter: { ...get().filter, ...filter } }),
  where: null,
  filter: initialAuditEffectsFilter,
}));

export const useAuditEffectsModal = () => {
  'use memo';

  const open = useStore(auditEffectsModalStore, (state) => state.open);
  const close = useStore(auditEffectsModalStore, (state) => state.close);

  return {
    open,
    close,
  };
};

export const useAuditEffectsModalFilter = (): {
  filter: AuditEffectsFilter;
  setFilter: (filter: Partial<AuditEffectsFilter>) => void;
} => {
  'use memo';

  const filter = useStore(auditEffectsModalStore, (state) => state.filter);
  const setFilter = useStore(
    auditEffectsModalStore,
    (state) => state.setFilter
  );

  return {
    filter,
    setFilter,
  };
};

export const useAuditEffectsModalWhere = () => {
  'use memo';

  return useStore(auditEffectsModalStore, (state) => state.where);
};
